import { render, staticRenderFns } from "./ChatUser.vue?vue&type=template&id=1694e4bc"
import script from "./ChatUser.vue?vue&type=script&lang=js"
export * from "./ChatUser.vue?vue&type=script&lang=js"
import style0 from "./ChatUser.vue?vue&type=style&index=0&id=1694e4bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports